import React from 'react';
import CustomHeader from '../components/CustomHeader';
import Footer from '../components/Footer';
import '../styles/screens/Terms.css';

const Terms: React.FC = () => {
  return (
    <div className="terms-container">
      <CustomHeader />

      {/* Main Content */}
      <main className="terms-content">
          <h1 className="terms-title">TERMS AND CONDITIONS OF USE</h1>
          <p className="terms-date">Last updated: August 2025</p>

          <section className="terms-section">
            <h2>1. ACCEPTANCE OF TERMS</h2>
            <p>
              By using RushHour, you agree to be bound by these Terms and Conditions. 
              If you do not agree to these terms, please do not use the application.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. SERVICE DESCRIPTION</h2>
            <p>
              RushHour is a parking assistance application that helps users manage parking 
              situations and communicate with other drivers. The app provides:
            </p>
            <ul>
              <li>Car registration and management with license plate numbers</li>
              <li>Reporting and tracking of blocking situations</li>
              <li>Smart notifications when blocking cars move</li>
              <li>Communication tools for parking coordination</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>3. USER RESPONSIBILITIES</h2>
            <p>As a user of RushHour, you agree to:</p>
            <ul>
              <li>Provide accurate and truthful information about your vehicles</li>
              <li>Maintain the security of your account and login credentials</li>
              <li>Use the service only for lawful parking assistance purposes</li>
              <li>Respect other users' privacy and rights</li>
              <li>Not use the service for harassment or malicious purposes</li>
              <li>Follow all applicable parking and traffic laws</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. PRIVACY AND DATA</h2>
            <p>
              We collect and process personal data as described in our Privacy Policy. 
              By using RushHour, you consent to such collection and processing.
            </p>
            <ul>
              <li>Your data is used to provide the parking assistance service</li>
              <li>We implement appropriate security measures to protect your information</li>
              <li>Vehicle information is shared only with relevant users in blocking situations</li>
              <li>We do not sell or share your personal data with third parties</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. LIMITATION OF LIABILITY</h2>
            <p>
              RushHour is provided "as is" without warranties. We are not liable for 
              any damages arising from the use of the service, including but not limited to:
            </p>
            <ul>
              <li>Parking violations or tickets</li>
              <li>Delays or missed appointments due to parking situations</li>
              <li>Damage to vehicles or property</li>
              <li>Service interruptions or technical issues</li>
              <li>Any damages resulting from reliance on app information</li>
            </ul>
            <p>
              Users are responsible for their own actions and decisions while using the service.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. INTELLECTUAL PROPERTY</h2>
            <p>
              RushHour, including its design, graphics, text, and software, is owned 
              by RushHour Technologies and is protected by copyright and other intellectual 
              property laws. You may not copy, modify, or distribute the app without 
              explicit permission.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. MODIFICATIONS</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will 
              be effective immediately upon posting. Your continued use of the service 
              constitutes acceptance of modified terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. TERMINATION</h2>
            <p>
              We may terminate or suspend your access to RushHour at any time, 
              with or without cause. You may also stop using the app at any time. 
              Upon termination, your right to use the service will cease immediately.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. GOVERNING LAW</h2>
            <p>
              These Terms shall be governed by and construed in accordance with 
              the laws of Israel. Any disputes shall be resolved in the courts 
              of Israel.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. CONTACT INFORMATION</h2>
            <p>
              For questions about these Terms or the RushHour service, please contact our support team:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> rush.hour.contact.us@gmail.com</p>
              {/* <p><strong>Legal Email:</strong> rush.hour.contact.us@gmail.com</p> */}
              {/* <p><strong>Address:</strong> RushHour Technologies, Israel</p> */}
            </div>
          </section>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
